module.exports = __webpack_public_path__ + "static/img/home-prove-3.81a78f44.jpg";